import { Dropdown, Space } from "antd";
import { LangEn, LangVn } from "../../assets";

import useLanguage from '../../hooks/useLanguage';

import './index.scss';

export const LANGUAGE = {
    VIETNAMESE: 'vi',
    ENGLISH: 'en'
}

const Lang = () => {
    const { language, setLanguage } = useLanguage()

    const items = [
        {
            key: '1',
            label: (
                <Space className="lang-wrapper" onClick={() => setLanguage(language == LANGUAGE.VIETNAMESE ? 'en' : LANGUAGE.VIETNAMESE)}>
                    <img src={language !== LANGUAGE.VIETNAMESE ? LangVn : LangEn} alt="" />
                    {language !== LANGUAGE.VIETNAMESE ? 'Vietnamese' : 'English'}
                </Space>
            ),
        },
    ];
    return <Dropdown
        menu={{
            items,
        }}
    >
        <a onClick={(e) => e.preventDefault()}>
            <Space className='lang'>
                <img className='d-block' src={language == LANGUAGE.VIETNAMESE ? LangVn : LangEn} alt="" />
            </Space>
        </a>
    </Dropdown>
}

export default Lang